<template>
  <div>
    <loading :active.sync="isLoading"
    :can-cancel="false"
    :is-full-page="fullPage"></loading>
    <div>
      <b-card no-body v-if="isAdmin">
        <b-tabs class="tab-title" pills card>
          <Geral :activeUsers=this.activeUsers :inactiveUsers=this.inactiveUsers />
          <Bonus />
          <ExtratoPJ />
          <ExtratoPF />
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
  import { userService } from '../../services/user_service';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Geral from './Geral.vue';
  import Bonus from './Bonus.vue';
  import ExtratoPJ from './ExtratoPJ.vue';
  import ExtratoPF from './ExtratoPF.vue';

  export default {
    name: 'Admin',
    components: {
      Loading,
      Geral,
      Bonus,
      ExtratoPJ,
      ExtratoPF
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        isAdmin: false,
        perPage: 15,
        currentPage: 1,
        adminInfoLoaded: false,
        activeUsers: 0,
        inactiveUsers: 0,
        users: [],
        totalRows: 1
      };
    },
    async mounted () {
      await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), adminTab: 'admin' });
      this.adminInfoLoaded = true;
    },
    async created () {

    },
    methods: {
      async loadUserAdminInfo (params) {
        this.isLoading = true;
        const result = await userService.userAdminInfo(params);
        if (result && result.length > 0) {
          this.isAdmin = true;
          this.activeUsers = result[1] ? result[1].active : this.activeUsers;
          this.inactiveUsers = result[2] ? result[2].nonActive : this.inactiveUsers;
          this.users = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        this.isLoading = false;
      }
    }
  };
</script>
<style>
.tab-content h3{
  font-family: Poppins;
  color: #207BDD;
}

.table {
  color: #6278A3;
}
.tab-title {
    margin-top: 70px;
}
.modal-body {
  margin-left: 8px;
  color: #6278A3;
}
.modal-body h5 {
  color: #6278A3;
}
.modal-title {
  color: #6278A3;
}
 .modal-body .btn-transparent {
    background-color: #e5e5e5;
    color: #007bff;
    font-weight: 500;
  }
  .modal-footer {
    justify-content: center;
  }
  .modal-footer > * {
    justify-content: space-between;
  }
  .modal-footer > button {
    justify-content: space-between;
  }
  .modal-footer .btn-transparent {
    background-color: #e5e5e5;
    color: #007bff;
    font-weight: 500;
    width: 114px;
    height: 34px;
  }
  .modal-footer .btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
    width: 114px;
    height: 34px;
  }
.badge {
  margin-left: 10px;
  padding: 6px;
}
.creditsBalance {
  text-align: left;
  color: #6278A3;
  font-family: Poppins;
  font-weight: 600;
  font-size: 14px;
}
.creditsBalanceRight {
  color: #6278A3;
  font-weight: 400;
  font-size: 14px;
}

</style>
